<div class="cms-edit-toolbar__view">
    <div
        class="cms-edit-toolbar__tool dynamic__element--pointer"
        (click)="onEditToolbarToolClicked(EditToolbarTool.DELETE)">
        <dynamo-icon dynamoIconType="delete" manualSize="1.2rem"></dynamo-icon>
        <span class="dynamic__text--xs">Kategorie löschen</span>
    </div>
</div>
